import { Section } from "component/section";
import { Text } from "component/text";
import { CART_ICONS } from "pages/cart/interfaces/icon";
import { Box } from "zmp-ui";
import DeliveryProvince from "../form/DeliveryProvince";
import DeliveryWard from "../form/DeliveryWard";
import "./style.scss";
import PhoneNumber from "../form/PhoneNumber";
import ReceiveName from "../form/ReceiveName";
import Address from "../form/Address";
import { THEME_SEMANTICS } from "component/theme/_semantics";

export const DeliveryInformation = () => {
  return (
    <Section>
      <Text style={{ display: 'flex', alignItems: 'center', marginTop: 0 }} fontSize={18} fontWeight={600}>
        <span className="mr-1">{CART_ICONS.delivery} </span>Thông tin giao hàng{" "}
        <Text color={THEME_SEMANTICS.failed} fontWeight={600}>&nbsp;*</Text>
      </Text>
      <Box>
        <Text fontSize={14} fontWeight={600}>
          Số điện thoại
        </Text>
        <PhoneNumber />
      </Box>
      <Box>
        <Text fontSize={14} fontWeight={600}>
          Tên người nhận
        </Text>
        <ReceiveName />
      </Box>
      <Box>
        <Text fontSize={14} fontWeight={600}>
          Số nhà, tên đường
        </Text>
        <Address />
      </Box>
      <Box>
        <Text fontSize={14} fontWeight={600}>
          Tỉnh/Thành phố
        </Text>
        <DeliveryProvince />
      </Box>
      <Box>
        <Text fontSize={14} fontWeight={600}>
          Phường/Xã
        </Text>
        <DeliveryWard />
      </Box>
    </Section>
  );
};
